module.exports = __webpack_public_path__ + "img/horizontal.1d2dc9a5.png";